import { throwIfAborted } from '../abort.js';
import { FundingConnectionError } from '../customer/connection-error.js';
/** Credentials are request-local, never part of purchase binding or persisted progress. */
export async function directPurchaseCredentials(provider, signal) {
    throwIfAborted(signal);
    const connection = await provider.getConnection({ skipKyc: true });
    throwIfAborted(signal);
    if (!connection.ok)
        throw new FundingConnectionError(connection.error);
    if (connection.value.status !== 'active')
        return undefined;
    const credentials = provider.getCredentials?.();
    if (!credentials)
        throw new Error('onramp_purchase_credentials_unavailable');
    if (!credentials.ok)
        throw new Error('onramp_purchase_credentials_unavailable');
    return { customerId: connection.value.customer.id, accessToken: credentials.value.accessToken };
}
export function directPurchaseHeaders(credentials) {
    return credentials
        ? {
            'X-MoonPay-Customer-Id': credentials.customerId,
            'X-MoonPay-Access-Token': credentials.accessToken,
        }
        : {};
}
